import { writable, type Writable } from 'svelte/store';

import { THEME_KEY } from '../configs';
import { ThemeModes } from '../types';

export interface CreateTheme extends Writable<ThemeModes> {
  toggleTheme: () => void;
  useLocalStorage: () => void;
}

const createTheme = (key: typeof THEME_KEY) => {
  const { set, update, subscribe }: Writable<ThemeModes> = writable(ThemeModes.Default);

  return {
    subscribe,
    toggleTheme() {
      update((value) => {
        const newMode = value === ThemeModes.Dark ? ThemeModes.Light : ThemeModes.Dark;

        if (value) document.documentElement.classList.remove(value);

        document.documentElement.classList.add(newMode);
        value = newMode;

        return value;
      });
    },
    init() {
      this.useLocalStorage();

      try {
        const localTheme = localStorage.getItem(key) as ThemeModes;

        if (
          localTheme === ThemeModes.Dark ||
          (!localTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)
        ) {
          set(ThemeModes.Dark);
        } else {
          set(ThemeModes.Light);
        }
      } catch {
        console.error('Failed to initialize theme');
      }
    },
    useLocalStorage() {
      subscribe((current) => {
        if (current) localStorage.setItem(key, current);
      });
    },
  };
};

export const theme = createTheme(THEME_KEY);

export const toggleTheme = theme.toggleTheme;
